import { render, staticRenderFns } from "./ProjectsInRevision.vue?vue&type=template&id=1a19da05&scoped=true&"
import script from "./ProjectsInRevision.vue?vue&type=script&lang=js&"
export * from "./ProjectsInRevision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a19da05",
  null
  
)

export default component.exports